import {loader} from '@monaco-editor/react';
import monacoPackage from 'monaco-editor/package.json';

export function configureMonaco() {
  const publicPath = new URL(process.env.PUBLIC_URL || '/', window.location.origin).pathname.replace(/\/$/, '');
  loader.config({paths: {vs: `${publicPath}/monaco/${monacoPackage.version}/vs`}});
}
